var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.437 11.626h1.418a.374.374 0 010 .747H6.437a.374.374 0 010-.747zM11.627 6.437v1.42c0 .223.186.373.373.373a.374.374 0 00.373-.374V6.437a.374.374 0 00-.747 0zM12.373 17.563v-1.419a.374.374 0 00-.373-.373c-.224 0-.373.15-.373.373v1.42c0 .223.186.373.373.373a.374.374 0 00.373-.374zM16.145 11.626h1.419a.374.374 0 010 .747h-1.42a.374.374 0 01-.372-.373c0-.224.149-.374.373-.374zM14.651 9.312l-2.427 2.427a.635.635 0 00-.373 0L8.527 8.415c-.149-.149-.373-.149-.522 0s-.15.374 0 .523l3.323 3.323c-.075.262 0 .56.224.747.075.075.224.15.336.187a.763.763 0 00.933-.747c0-.075 0-.112-.037-.187l2.427-2.427c.299-.373-.224-.858-.56-.522z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.41 4.01a8.017 8.017 0 00-8.4 8.4c.223 4.07 3.51 7.357 7.58 7.58a8.017 8.017 0 008.4-8.4c-.223-4.07-3.51-7.357-7.58-7.58zm.225 14.86c-4.294.374-7.879-3.21-7.506-7.505.3-3.286 2.95-5.937 6.236-6.236 4.294-.373 7.879 3.212 7.506 7.506-.3 3.286-2.95 5.937-6.236 6.236z"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--clock-159d486227f58256569fa8096f292996.svg";
export { SvgIconCircleLimeClock as Component };